import { TableCell } from "@/ds/shadcn/components/ui/table";
import { ListItem, ListItemMenu } from "@/features/common/components/dataview/ListItem";
import { usePriceAlertUpdate } from "@/features/priceAlerts/api/usePriceAlertUpdate";
import { PriceAlertMetricLabels } from "@/features/priceAlerts/PriceAlertMetric";
import { PriceAlertsMenu, PriceAlertsMetricDisplay, PriceAlertsStatusBadge, toggleEnabledPriceAlert, type PriceAlertsDataViewProps } from "@/features/priceAlerts/components/PriceAlertRowDisplays";
import { PriceAlertTargetDisplay } from "@/features/priceAlerts/components/PriceAlertTargetDisplay";
import { PriceAlertTargetLabels } from "@/features/priceAlerts/PriceAlertTarget";
import type { FC } from "react";

export const PagePriceAlertsDataViewListItem: FC<PriceAlertsDataViewProps> = priceAlert => {
	const {
		targetType,
		metricType,
		onDeletePriceAlert,
		onEditPriceAlert,
		onViewPriceAlert
	} = priceAlert;

	const updatePriceAlert = usePriceAlertUpdate();

	return (
		<ListItem isLoading={updatePriceAlert.isPending} error={updatePriceAlert.error} onClick={() => onEditPriceAlert(priceAlert)}>
			<TableCell>
				<PriceAlertTargetDisplay {...priceAlert} className="w-8 rounded-[5%] aspect-400/558 bg-cover" />
			</TableCell>
			<TableCell>
				<div className="type-item">{PriceAlertMetricLabels[metricType]}</div>
				<div className="type-meta">{PriceAlertTargetLabels[targetType]}</div>
			</TableCell>
			<TableCell>
				<PriceAlertsMetricDisplay {...priceAlert} />
			</TableCell>
			<TableCell>
				<PriceAlertsStatusBadge enabled={priceAlert.enabled} />
			</TableCell>
			<TableCell onClick={e => e.stopPropagation()}>
				<ListItemMenu>
					<PriceAlertsMenu
						priceAlert={priceAlert}
						onEnabledPriceAlert={() => toggleEnabledPriceAlert(priceAlert, updatePriceAlert)}
						onViewPriceAlert={onViewPriceAlert}
						onDeletePriceAlert={onDeletePriceAlert} />
				</ListItemMenu>
			</TableCell>
		</ListItem>
	);
};
